import React from 'react';
import axios from 'axios';
import fileDownload from 'js-file-download';

import { useTimeModal } from '../TimeModal/TimeModalContext';
import { formatDateTime } from '../../Utils/GlobalUtils';

import Loading from '../Loading';

import styles from '../../styles/DynamicModal.module.css';

const FilesCase = ({ caseId, access, onFileSuccess, sideReload }) => {
    const { openTimeModal } = useTimeModal();

    const [files, setFiles] = React.useState([]);
    const [commentsNull, setCommentsNull] = React.useState('');
    const [warning, setWarning] = React.useState('');
    const [reload, setReload] = React.useState(true);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        const token = localStorage.getItem('token');

        axios.get(`/api/get-files?caseId=${caseId}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        }
        })
        .then(response => {
            if (response.data.length === 0) {
                setCommentsNull('Файлы не прикреплены');
            } else {
                setWarning('');
                setFiles(response.data);
            }
        })
        .catch(error => {
            setWarning(`Ошибка при загрузке списка прикрепленных файлов:  ${error.response?.data.message || error.message}`);
        })
        .finally(() => {
            setLoading(false);
            setReload(false);
        })
    }, [reload, caseId, sideReload]);

    const [confirmFileDelete, setConfirmFileDelete] = React.useState(null);
    const deleteFile = (fileId) => {
        axios.delete(`/api/delete-file?fileId=${fileId}`)
        .then(() => {
            onFileSuccess();
        })
        .catch(() => {
            openTimeModal('Ошибка при удалении файла', 'error');
        })
        .finally(() => {
            setReload(true);
        });
    };
    const handleDeleteFileClick = (fileId) => {
        if (confirmFileDelete === fileId) {
            deleteFile(fileId);
            setConfirmFileDelete(null);
        } else {
            setConfirmFileDelete(fileId);
        }
        setTimeout(() => {
            setConfirmFileDelete(null);
        }, 2000);
    };
    const downloadFile = async (id) => {
        const token = localStorage.getItem('token');

        setLoading(true);

        try {
            const response = await axios.get(`/api/download-case-file/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: 'blob',
            });
    
            const contentDisposition = response.headers['content-disposition'];
            let fileName = `file_${id}.pdf`; // Файл по умолчанию
            
            if (contentDisposition) {
                const fileNameMatch = contentDisposition.match(/filename\s*=\s*"([^"]+)"/);
                if (fileNameMatch && fileNameMatch[1]) {
                    fileName = decodeURIComponent(fileNameMatch[1]);
                }
            }
    
            console.log('Downloading file:', fileName);
            fileDownload(response.data, fileName);
        } catch (error) {
            console.error('Ошибка при скачивании файла: ', error);
            setTimeout(() => setWarning('Не удалось скачать файл: Файл мог быть уничтожен.'), 2000);
        } finally {
            setLoading(false);
        }
    };
    
    const isWithinLastHalfHour = (creationTime) => {
        const now = new Date();
        now.setHours(now.getHours() + 3); // Перевод в МСК
        const creationDate = new Date(creationTime);
        const diffInMinutes = (now - creationDate) / (1000 * 60);
        return diffInMinutes <= 30;
    };

    return (
        loading ? <Loading /> 
        : warning ? <a className={styles.statusPanel}><img src='/img/icons/warning-icon.svg' alt='Предупреждение' />{warning}</a>
        : commentsNull ? <a style={{color: 'rgb(169, 169, 169)'}}>{commentsNull}</a>
        : files.map((fileInfo) => (
            <div className={styles.caseComponentLine} key={fileInfo.id}>
                <span>
                    <a>{fileInfo.name}</a>
                    <a className={styles.time}>{formatDateTime(fileInfo.created_at)}</a>
                </span>
                <div className={styles.commentActions}>
                    {confirmFileDelete === fileInfo.id ? (
                        <button 
                            className="button miniButton" 
                            style={{fontSize: '12px', margin: '0 0 0 10px'}}
                            onClick={() => handleDeleteFileClick(fileInfo.id)}
                        >
                            Удалить?
                        </button>
                    ) : (
                        <>
                            <img src='/img/icons/eye.svg' alt='Просмотреть' title='Просмотреть' onClick={() => window.open(`/file/${fileInfo.id}`, '_blank')} />
                            <img src='/img/icons/download-alt.svg' alt='Скачать' title='Скачать' onClick={() => downloadFile(fileInfo.id)} />
                            {(access || isWithinLastHalfHour(fileInfo.created_at)) && (
                                <img src='/img/icons/trash.svg' alt='Удалить' title='Удалить' onClick={() => handleDeleteFileClick(fileInfo.id)} />
                            )}
                        </>
                    )}
                </div>
            </div>
        ))
    )
}

export default FilesCase;